export default "__VITE_ASSET__Dyn6m06q__"